import { BaseController } from "@/controllers/model-controllers/abstract/base-controller"

export abstract class BaseModelController extends BaseController {}
